import React, { useEffect, useState } from "react";
import classes from "./bannermanagementheadre.module.scss";
import { GiHamburgerMenu } from "react-icons/gi";
import OffcanvasMain from "../Offcanvas";
import SideBar from "../SideBar";
import ModalMain from "../Modal";
import { useTranslation } from "react-i18next";
import CreateBanner from "../../ModalComponents/BannerManagementModal/CrateBanner";
import CarteBannerIcon from "../../../assets/icons/CarteBannerIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  actionBannerListApiCall,
  setperPageBannerCount,
} from "../../../Redux/Actions";
import { useMemo } from "react";

const BannerManagementHeadre = () => {
  const { t } = useTranslation();
  const state = useSelector((state) => state.CommonReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sidebar, setSideBar] = useState(false);
  const [creatbanner, setCreateBanner] = useState(false);
  const [selectedOption, setSelectedOption] = useState(false);
  const [perpage, setPerPage] = useState(
    state?.perPageBannerCount ? state?.perPageBannerCount : 40
  );
  const [inputType, setInputType] = useState("text");
  const [inputType1, setInputType1] = useState("text");
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const filterClick = () => {
    const data = {
      page: 1,
      per_page: perpage,
      position: selectedOption,
      start_date: startDate,
      end_date: endDate,
    };
    const body = { data, navigate };

    dispatch(actionBannerListApiCall(body));
  };
  useMemo(() => {
    filterClick();
    dispatch(setperPageBannerCount(perpage));
  }, [perpage]);

  const positionArray = [
    { value: "Home Top" },
    { value: "Home Left" },
    { value: "Home Right" },
    { value: "Home Middle" },
    { value: "Home Ad 1" },
    { value: "Home Ad 2" },
    { value: "Home Ad 3" },
    { value: "Home Ad 4" },
    { value: "Search Ad 1" },
    { value: "Search Ad 2" },
    { value: "Search Ad 3" },
    { value: "Search Ad 4" },
    { value: "Listing View Ad 1" },
    { value: "Listing View Ad 2" },
    { value: "Listing View Ad 3" },
    { value: "Listing View Ad 4" },
  ];
  const handleFocus = () => {
    setInputType("date");
  };
  const handleFocus1 = () => {
    setInputType1("date");
  };
  const handleBlur = () => {
    setInputType("text");
  };
  const handleBlur1 = () => {
    setInputType1("text");
  };
  const sidebarShow = () => {
    setSideBar(true);
  };
  const createBannerShow = () => {
    setCreateBanner(true);
  };

  const handleClose = () => {
    setSideBar(false);
    setCreateBanner(false);
  };

  return (
    <React.Fragment>
      <div className={classes.HeaderWrap}>
        <div className={classes.ManagmentSection}>
          <div className={classes.CanvasWarp}>
            <button onClick={sidebarShow}>
              <GiHamburgerMenu />
            </button>
          </div>
          <div className={classes.FilterSection}>
            <h5>{t("banner_management")}</h5>
            <form>
              <div className={classes.managementFild}>
                <div className={classes.fildBox}>
                  <select
                    id="status"
                    name="position"
                    onChange={(e) => setSelectedOption(e.target.value)}
                  >
                    <option value="" disabled selected>
                      {`${t("position")}...`}
                    </option>
                    {positionArray.map((item) => {
                      return <option value={item.value}>{item.value}</option>;
                    })}
                  </select>
                </div>
                <div className={classes.fildBox}>
                  <input
                    type={inputType}
                    placeholder="Start Date"
                    onChange={(event) => {
                      if (event.target.type == "date") {
                        setStartDate(event.target.value);
                      }
                    }}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                  />
                </div>
                <div className={classes.fildBox}>
                  <input
                    type={inputType1}
                    placeholder="End Date"
                    onChange={(event) => {
                      if (event.target.type == "date") {
                        setEndDate(event.target.value);
                      }
                    }}
                    onFocus={handleFocus1}
                    onBlur={handleBlur1}
                  />
                </div>
                <div
                  className={classes.fildBox}
                  onClick={(e) => {
                    e.preventDefault();
                    filterClick();
                  }}
                >
                  <button>{t("filter")}</button>
                </div>
              </div>
            </form>
          </div>
          <div className={classes.ManagbBnnerSection}>
            <button onClick={createBannerShow}>
              {t("create_banner")}
              <img src={CarteBannerIcon} />
            </button>
          </div>
        </div>
        <div className={classes.BannersPerPageSection}>
          <p>{t("banner_per_page")}</p>
          <div className={classes.numberOfUser}>
            <select
              id="page"
              name="page"
              onChange={(e) => setPerPage(e.target.value)}
            >
              <option value={40} selected={40 == perpage}>
                40
              </option>
              <option value={50} selected={50 == perpage}>
                50
              </option>
              <option value={60} selected={60 == perpage}>
                60
              </option>
              <option value={70} selected={70 == perpage}>
                70
              </option>
            </select>
          </div>
        </div>
      </div>
      <OffcanvasMain showcanvas={sidebar} handleClose={handleClose}>
        <SideBar />
      </OffcanvasMain>
      <ModalMain showmodel={creatbanner} handleClose={handleClose} size={"md"}>
        <CreateBanner onClose={handleClose} edit={false} />
      </ModalMain>
    </React.Fragment>
  );
};

export default BannerManagementHeadre;
